import { DatePipe, registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withInMemoryScrolling, withRouterConfig } from "@angular/router";
import { environment } from "@environment";
import { AuthorizeGuard } from "@guards/authorize.guard";
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { BroadcastService } from "@services/broadcast.service";
import { AuthService, LoadingService, MessagesService, StatsService } from "@services/services";
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from "ng-recaptcha-2";
import { providePrimeNG } from 'primeng/config';
import { routes } from "./app.routes";
import { ApiModule, Configuration } from "./client";
import { GlobalErrorHandler } from "./handlers/error-handler";
import { tokenInterceptor } from "./interceptors/token.interceptor";

registerLocaleData(localeEs);
const AutoescuelaPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f2fbfd',
      100: '#ddf5fa',
      200: '#bcebf4',
      300: '#8edceb',
      400: '#56c6e6',
      500: '#31a9cf',
      600: '#2e81af',
      700: '#28698f',
      800: '#255876',
      900: '#234a62',
      950: '#163044',
    },
  },
});
export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideZoneChangeDetection(),
providePrimeNG({
  theme: {
    preset: AutoescuelaPreset,
    options: {
      darkModeSelector: false
    }
  },
  license: environment.primeUiLicense
}),
    provideHttpClient(
      withInterceptors([
        tokenInterceptor   // nuevo
      ]),
      withInterceptorsFromDi() // antiguos
    ),
    importProvidersFrom(ApiModule.forRoot(() => new Configuration({ basePath: environment.apiUrl }))),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes,  withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey
      } as RecaptchaSettings,
    },
    AuthService,
    BroadcastService,
    LoadingService,
    MessagesService,
    StatsService,
    AuthorizeGuard,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LOCALE_ID, useValue: 'es-ES' },

    // Registrar PWA (puedes moverlo a otro sitio si quieres)
    // ...(environment.production ? [ServiceWorkerModule.register('ngsw-worker.js')] : []),
  ]
}
